import React, { useCallback } from 'react'

import type { AdapterKitControlProps } from 'components/formKit/types'
import type { ITimePickerProps } from 'components/uiKit/TimePicker'
import TimePicker from 'components/uiKit/TimePicker'

const FieldTime = ({
  name,
  onChange,
  ...rest
}: AdapterKitControlProps<ITimePickerProps, number | null>) => {
  const handleChange = useCallback(
    (value: number | null) => onChange({ name, value }),
    [name, onChange],
  )

  return <TimePicker {...rest} name={name} onChange={handleChange} />
}

export default React.memo(FieldTime) as typeof FieldTime
